// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function BellBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M28.161 20.741C27.076 18.875 26.5 16.196 26.5 13a10.5 10.5 0 0 0-21 0c0 3.198-.574 5.875-1.659 7.741a2.51 2.51 0 0 0 .905 3.429c.381.22.814.333 1.254.33h4.523a5.5 5.5 0 0 0 10.954 0H26a2.472 2.472 0 0 0 2.164-1.25 2.51 2.51 0 0 0-.003-2.509ZM16 26.5a2.5 2.5 0 0 1-2.45-2h4.9a2.5 2.5 0 0 1-2.45 2Zm-9.168-5C7.94 19.25 8.5 16.392 8.5 13a7.5 7.5 0 0 1 15 0c0 3.391.56 6.25 1.666 8.5H6.832Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
